module.exports = __webpack_public_path__ + "img/MSTART-default-back.37e47c81.jpg";